<template>
    <RelatedItem v-if="itemContainer != null" :item="itemContainer"/>
    <RelatedItemShimmer v-else :item="itemContainer"/>
</template>

<script setup>
import {
    itemsV3Client,
    itemBundlesClient,
} from "@/assets/apis/config";
import RelatedItem from "./RelatedItem.vue";
import RelatedItemShimmer from "./RelatedItemShimmer.vue";

const props = defineProps({
    item: {
        type: Object,
        default: null,
    }
});

// const itemRef = toRef(props, 'item');
const itemContainer = ref(null);


const fetchData = async (id, type) => {
    let res = null;
    if (type == 'item') {
        res = await itemsV3Client.findOneJoin({ id: id, fetchSkus: true });
    } else if (type == 'bundle') {
        res = await itemBundlesClient.findOneJoin({ id: id, fetchSkus: true, fetchItems: true, fetchSkuDetails: true});
    }

    if (res.networkError) {
        /* TODO: show message */
        return;
    }

    if (res.status == 200 && res.body) {
        let itemBody = res.body;
        let categories = itemBody?.categories?.length ? itemBody.categories.map(i => i.category) : [];
        let collections = itemBody?.collections?.length ? itemBody.collections.map(i => i.collection) : [];
        
        if (type == 'item') {
            itemContainer.value = {
                ...itemBody.item,
            }
        }
        if (type == 'bundle') {
            itemContainer.value = {
                ...itemBody.bundle,
                items: itemBody?.items,
                skuDetails: itemBody?.skuDetails,
            }
        }

        itemContainer.value.categories = categories;
        itemContainer.value.lookups = itemBody.lookups;
        itemContainer.value.keywords = itemBody.keywords;
        itemContainer.value.images = itemBody.attachments;
        itemContainer.value.skus = itemBody.skus;
        itemContainer.value.collections = collections;
    } else {
        return;
    }
}

watch(() => props.item, async () => {
    if (props.item?.item?.item?.id?.length) {
        await fetchData(props.item.item.item.id, 'item')
    }
},{deep: true, immediate: true});
</script>

<style lang="scss">
.item-item-img {
    min-height: 300px;
}
</style>